import _classCallCheck from "/opt/build/repo/node_modules/@babel/runtime/helpers/esm/classCallCheck.js";
import _createClass from "/opt/build/repo/node_modules/@babel/runtime/helpers/esm/createClass.js";
import _inherits from "/opt/build/repo/node_modules/@babel/runtime/helpers/esm/inherits.js";
import _possibleConstructorReturn from "/opt/build/repo/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn.js";
import _getPrototypeOf from "/opt/build/repo/node_modules/@babel/runtime/helpers/esm/getPrototypeOf.js";
import _regeneratorRuntime from "/opt/build/repo/node_modules/@babel/runtime/regenerator/index.js";
function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }
function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
var a = function a(i, s, e) {
  return new Promise(function (u, c) {
    var l = function l(n) {
        try {
          r(e.next(n));
        } catch (t) {
          c(t);
        }
      },
      p = function p(n) {
        try {
          r(e.throw(n));
        } catch (t) {
          c(t);
        }
      },
      r = function r(n) {
        return n.done ? u(n.value) : Promise.resolve(n.value).then(l, p);
      };
    r((e = e.apply(i, s)).next());
  });
};
import { Extension as g } from "@magic-sdk/commons";
var o = /*#__PURE__*/function (_g$Internal) {
  _inherits(o, _g$Internal);
  var _super = _createSuper(o);
  function o(e) {
    var _this;
    _classCallCheck(this, o);
    _this = _super.call(this);
    _this.nearConfig = e;
    _this.name = "near";
    _this.config = {};
    _this.config = {
      rpcUrl: e.rpcUrl,
      chainType: "NEAR"
    };
    return _this;
  }
  _createClass(o, [{
    key: "signTransaction",
    value: function signTransaction(e) {
      return a(this, null, /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              return _context.abrupt("return", this.request(this.utils.createJsonRpcRequestPayload("near_signTransaction", e)));
            case 1:
            case "end":
              return _context.stop();
          }
        }, _callee, this);
      }));
    }
  }, {
    key: "getPublicKey",
    value: function getPublicKey() {
      return a(this, null, /*#__PURE__*/_regeneratorRuntime.mark(function _callee2() {
        return _regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) switch (_context2.prev = _context2.next) {
            case 0:
              return _context2.abrupt("return", this.request(this.utils.createJsonRpcRequestPayload("near_getPublicKey", [])));
            case 1:
            case "end":
              return _context2.stop();
          }
        }, _callee2, this);
      }));
    }
  }]);
  return o;
}(g.Internal);
export { o as NearExtension };